// extracted by mini-css-extract-plugin
module.exports = {"iconBtn":"styles_iconBtn__1Kgl-","cancel":"styles_cancel__2ucpU"};